import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { fetchData } from 'reducers/monitorsAndAlerts/reducer'
import ListFromTable from 'components/common/ListFromTable'
import ColumnCollection from 'types/table/ColumnCollection'
import Column from 'types/table/Column'
import Filters from '../Filters'
import messages from '../../translate'
import Indicator from './Indicators'

class Table extends ListFromTable {
  constructor(props) {
    super(props)
    this.asyncData = true
    this.loadingData = true
  }

  getTableData = payload => {
    this.props.fetchData(payload)
  }

  getParams = props => {
    const params = {}
    const {
      activeSite,
      activeLocus,
      siteList,
      locusList,
      activeCriteria,
      activeIndicators,
      includeLevelLower,
    } = props
    const activeSiteId = activeSite.get('id')
    const activeLocusId = activeLocus.get('id')

    if (activeSiteId !== 0) {
      params.site = activeSiteId
    }

    if (activeLocusId !== 0) {
      params.locus = activeLocusId
    }

    if (includeLevelLower) {
      params.include_level_lower = 1
      const checkClearData = (list, key, check) => {
        if (!check) {
          return
        }

        if (list.size) {
          params[key] = list
            .toArray()
            .map(item => item.id)
            .join()
        } else {
          params.clearData = true
        }
      }

      checkClearData(siteList, 'sites', !activeSiteId)
      checkClearData(locusList, 'locuses', activeSiteId && !activeLocusId)
    }

    if (activeSite.get('id') !== 0) {
      params.site = activeSite.get('id')
    }

    if (activeCriteria.size > 0) {
      const ac = []
      activeCriteria.toArray().map(item => ac.push(item.id))
      this.psfs.addFilter('policy', ac, 'in')
    } else {
      this.psfs.filtersObj.clearFilter('policy')
    }

    if (activeIndicators.size > 0) {
      const ai = []
      activeIndicators.toArray().map(item => ai.push(item.id))
      this.psfs.addFilter('criticality_level', ai, 'in')
    } else {
      this.psfs.filtersObj.clearFilter('criticality_level')
    }

    return params
  }

  reloadTableData(path, props) {
    this.psfs.init(path)
    const params = this.getParams(props)

    this.getTableData({
      psfs: this.psfs,
      params,
    })
  }

  componentDidMount() {
    this.getTableData({
      psfs: this.psfs,
      params: this.getParams(this.props),
    })
  }

  shouldComponentUpdate(nextProps, nextState) {
    this.loadingData = nextProps.loader

    const {
      activeLicensee: prevActiveLicensee,
      activeSite: prevActiveSite,
      activeLocus: prevActiveLocus,
      activeCriteria: prevActiveCriteria,
      activeIndicators: prevActiveIndicators,
      siteList: prevSiteList,
      locusList: prevLocusList,
      includeLevelLower: prevIncludeLevelLower,
      location: { pathname: prevLocationPathname } = {},
    } = this.props
    const {
      activeLicensee,
      activeSite,
      activeLocus,
      activeCriteria,
      activeIndicators,
      siteList,
      locusList,
      includeLevelLower,
      isStateCriteria,
      location: { pathname: locationPathname } = {},
    } = nextProps
    const { pathname: prevPathname } = this.state
    const { pathname } = nextState
    const isChangeProps =
      prevActiveLicensee !== activeLicensee ||
      prevActiveSite !== activeSite ||
      prevActiveLocus !== activeLocus ||
      prevActiveCriteria !== activeCriteria ||
      prevActiveIndicators !== activeIndicators ||
      prevIncludeLevelLower !== includeLevelLower ||
      (includeLevelLower && prevSiteList !== siteList) ||
      (includeLevelLower && prevLocusList !== locusList)

    if (isChangeProps) {
      this.reloadTableData(
        isStateCriteria ? pathname : locationPathname,
        nextProps,
      )

      return false
    }

    if (!isStateCriteria && locationPathname !== prevLocationPathname) {
      this.reloadTableData(locationPathname, nextProps)

      return false
    }

    if (isStateCriteria && pathname !== prevPathname) {
      this.reloadTableData(pathname, nextProps)

      return false
    }

    return true
  }

  getTableProps() {
    const { alwaysShowTableHead, lang } = this.props

    return {
      showFilterBar: false,
      sorting: true,
      paging: false,
      searching: false,
      creating: false,
      className: 'ma-table',
      alwaysShowTableHead,
      lang,
    }
  }

  getColumns() {
    const {
      intl: { formatMessage },
    } = this.props
    const columns = new ColumnCollection()

    columns.add(
      new Column('', <Filters />, {
        render({ criticality_level }) {
          return (
            <span className={`material-icons ${criticality_level}`}>lens</span>
          )
        },
      }),
    )
    columns.add(
      new Column('indicatorName', formatMessage(messages.indicatorName), {
        render(rowData) {
          const { policy, site, locus } = rowData
          let lowerLevel = ''

          if (site !== null) {
            lowerLevel = site.name

            if (locus !== null) {
              lowerLevel += ` - ${locus.name}`
            }
          }

          return (
            <>
              <div className="ma-table-policy-name">
                {formatMessage({ id: policy.name })}
              </div>
              <div className="ma-table-lover-level">{lowerLevel}</div>
            </>
          )
        },
      }),
    )
    columns.add(
      new Column('indicatorValue', formatMessage(messages.indicatorValue), {
        render(rowData) {
          return <Indicator {...rowData} />
        },
      }),
    )

    return columns
  }
}

export default connect(
  state => ({
    activeLicensee: state.getIn(['monitorsAndAlerts', 'activeLicensee']),
    activeSite: state.getIn(['monitorsAndAlerts', 'activeSite']),
    activeLocus: state.getIn(['monitorsAndAlerts', 'activeLocus']),
    siteList: state.getIn(['monitorsAndAlerts', 'siteList']),
    locusList: state.getIn(['monitorsAndAlerts', 'locusList']),
    activeCriteria: state.getIn(['monitorsAndAlerts', 'activeCriteria']),
    activeIndicators: state.getIn(['monitorsAndAlerts', 'activeIndicators']),
    includeLevelLower: state.getIn(['monitorsAndAlerts', 'includeLevelLower']),
    loader: state.getIn(['monitorsAndAlerts', 'isLoadTable']),
    tableData: state.getIn(['monitorsAndAlerts', 'data']),
    lang: state.getIn(['locale', 'lang']),
  }),
  {
    fetchData,
  },
)(injectIntl(Table))
